import DevicesTemplate from './devices.html';

export default angular
  .module('main.devices.edit.tabs.devices', [])

  .directive('editDeviceDevicesTab', () => {
    return {
      restrict: 'E',
      template: DevicesTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $filter,
                   $interval,
                   $q,
                   utils,
                   PermissionsService,
                   EditDeviceDataProvider) => {
        $scope.dataProvider = EditDeviceDataProvider.instance;

        const $t = $filter('translate');
        $scope.timeFormatStr = $t('datetime.mdyHM12');

        // Reload devices interval
        const DEVICES_UPDATE_INTERVAL = 5000;
        let reloadDevicesInterval;

        angular.extend($scope, {
          canEditDevice: canEditDevice,
          goToEditDevice: goToEditDevice,
          showMoreTags: showMoreTags,
          copyToClipboard: $rootScope.copyToClipboard,
          registerDevice: registerDevice,
        });

        // Remove locations refresh interval
        $scope.$on('$destroy', () => {
          stopDevicesRefresh();
        });

        init();

        function init() {
          $scope.loading = true;
          $q.all([
            $scope.dataProvider.deviceTypesResource.init(),
            $scope.dataProvider.gatewayDevicesResource.init()
          ])
            .then(() => {
              initViewModel();
              initWatchers();
              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
              // utils.handleApiError(err);
            });
        }

        function initWatchers() {
          $scope.$watchGroup([
            'dataProvider.deviceTypesResource.value',
            'dataProvider.gatewayDevicesResource.value'
          ], () => {
            if ($scope.dataProvider.deviceTypesResource.loading || $scope.dataProvider.gatewayDevicesResource.loading) {
              return;
            }
            initViewModel();
          }, true);

          // Reload devices when switching to 'devices' tab
          $scope.$watch('dataProvider.activeTab', (newVal, oldVal) => {
            if (newVal === 'devices') {
              startDevicesRefresh();
            } else if (oldVal === 'devices') {
              stopDevicesRefresh();
            }
          });
        }

        function initViewModel() {
          const allDevices = angular.copy($scope.dataProvider.gatewayDevicesResource.value);

          // Process Devices
          $scope.prospectDevices = [];
          $scope.devices = allDevices.reduce((acc, device) => {

            // Identify Prospect Devices
            if (device.status && device.status === 2) {
              $scope.prospectDevices.push(device);
            } else {
              let deviceType = angular.copy($scope.dataProvider.deviceTypesResource.value.find(t => t.id === device.type));
              if (deviceType) {
                utils.appendAttr2DeviceType(deviceType);
                device.typeDesc = deviceType.name;
                device.deviceListIcon = deviceType.deviceListIcon;
                device.dTypeIcon = deviceType.iconUrl;
              }
              acc.push(device);
            }
            return acc;

          }, []);
        }

        /**
         * Reload devices every 5 sec
         */
        function startDevicesRefresh() {
          if (reloadDevicesInterval) {
            $interval.cancel(reloadDevicesInterval);
          }

          reloadDevicesInterval = $interval(() => {
            $scope.dataProvider.gatewayDevicesResource.init(true)
              .then(() => initViewModel());
          }, DEVICES_UPDATE_INTERVAL);
        }

        function stopDevicesRefresh() {
          if (reloadDevicesInterval) {
            $interval.cancel(reloadDevicesInterval);
          }
        }

        function canEditDevice(device) {
          return PermissionsService.canIEditDevice(device);
        }

        function goToEditDevice(device, tabName) {
          if ($scope.loading || !device || !canEditDevice(device)) {
            return;
          }
          let originalDevice = $scope.dataProvider.gatewayDevicesResource.value.find(d => d.id === device.id);
          $scope.dataProvider.goToDevice(originalDevice, tabName);
        }

        function showMoreTags(device) {
          goToEditDevice(device);
        }

        function registerDevice(device) {
          if ($scope.loading || !device || !canEditDevice(device)) {
            return;
          }
          $scope.dataProvider.registerDevice(device);
        }
      }
    };
  })
  .name;
